<template>
  <div class="innerPage">
    <div class="innerPageHead">
      <div class="innerPageTitle">
        <h2>{{ $t("TopNav06") }}</h2> 
      </div>
      <div class="innerPagePagination">
        <b-container>
          <b-breadcrumb :items="items"></b-breadcrumb>
        </b-container>
      </div>
    </div>

    <div class="interPageMainContain">
      <b-container>
        <h3 class="font-weight-bold">{{ $t("venu_site") }}</h3>
        <p>{{ $t("venu_address") }}</p>
        <b-row align-h="center">
          <b-col cols="12" lg="4" class="mb-4">
            <b-img
              :src="require('@/assets/imgs/siteInfo_map.png')"
              fluid
              alt=""
            ></b-img>
          </b-col>
          <b-col cols="12" lg="8">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3615.1163727760672!2d121.52550071500609!3d25.03012448397414!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3442a98364e9ea11%3A0xe243b6d5a0aa5f17!2zMTA25Y-w5YyX5biC5aSn5a6J5Y2A6YeR6I-v6KGXMTg36Jmf!5e0!3m2!1szh-TW!2stw!4v1626244984959!5m2!1szh-TW!2stw" width="100%" height="380" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <h4 class="font-weight-bold pb-2 pt-3">{{ $t("Transportation_Title_01") }}</h4>
            <ul>
              <li>{{ $t("Transportation_01-1") }}</li>
              <li>{{ $t("Transportation_01-2") }}</li>
              <li>{{ $t("Transportation_01-3") }}</li>
            </ul>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <h4 class="font-weight-bold pb-2 pt-3">{{ $t("Transportation_Title_02") }}</h4>
            <ul>
              <li>{{ $t("Transportation_02-1") }}</li>
              <li>{{ $t("Transportation_02-2") }}</li>
              <li>{{ $t("Transportation_02-3") }}</li>
              <li>{{ $t("Transportation_02-4") }}</li>
            </ul>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <h4 class="font-weight-bold pb-2 pt-3">U-bike</h4>
            <p>{{ $t("Transportation_Title_03") }}</p>
            <ul>
              <li>{{ $t("Transportation_03-1") }}</li>
            </ul>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" lg="11">
            <h4 class="font-weight-bold pb-2 pt-3">{{ $t("Transportation_Title_04") }}<a href="https://cpbae.nccu.edu.tw/cpbae-service-nx2/parking?random=1783925500774" target="_blank" class="btn mainBtn ml-3">{{ $t("Transportation_04-1") }}</a></h4>
            <p>{{ $t("Transportation_04-2") }}</p>
            <p>{{ $t("Transportation_04-3") }}</p>
            <ol>
              <li>{{ $t("Transportation_04-4") }}</li>
              <li>{{ $t("Transportation_04-5") }}</li>
            </ol>
            {{ $t("Transportation_04-6") }}
          </b-col>
        </b-row>
      </b-container>


    </div>    
    <ul id="myMenu">
      <li>
        <b-link to="/" tooltip="首頁" flow="left"
          ><span class="icon-home" :title="$t('rightNav01')"></span
          ><span class="sr-only">{{ $t("TopNav01") }}</span>
        </b-link>
      </li>
      <li>
        <a
          href="https://www.surveycake.com/s/DrWBR"
          target="_blank"
          tooltip="報名論壇"
          flow="left"
          :title="$t('rightNav02-1')"
          ><span class="icon-user-plus"></span>
          <span class="sr-only">{{ $t("TopNav05") }}</span></a
        >
      </li>
      <li>
        <a
          href="javascript:"
          v-scroll-to="'#top'"
          :title="$t('rightNav07')"
          ><span class="icon-arrow_up"></span><span class="sr-only">top</span></a
        >
      </li>
    </ul>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        navigationActive: [],
        items: [
          {
            text: this.$t("TopNav01") ,
            href: "#/",
          },
          {
            text: this.$t("TopNav06") ,
            active: true,
          },
        ],
      };
    },
    mounted() {
      window.scrollTo(0, 0);
      window.addEventListener("scroll", this.updateScroll);
    },
    methods: {

    },
  };
</script>
<style lang="scss"></style>
